import { Grid } from '@material-ui/core';
import React from 'react';
import moment from 'moment';

const calendarHeader = ({ weekDays, startDate, cellHeight }) => {
    return (
        <Grid container item xs={12}>
            {[...Array(weekDays).keys()].map((day, dayIdx) => {
                const currentDay = moment(startDate).add(dayIdx, 'days');
                return (
                    <div
                        key={dayIdx}
                        style={{
                            width: `calc(100% / ${weekDays})`,
                            height: `${cellHeight}px`
                        }}
                        className="ch-border-right-bottom"
                    >
                        {currentDay.format('ddd')}
                        <br />
                        <span className="day">{currentDay.format('D')}</span>
                    </div>
                );
            })}
        </Grid>
    );
};

export default calendarHeader;
